import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SelectorComponent } from './selector/selector.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatTableModule } from '@angular/material/table';
import { MatCardModule } from '@angular/material/card';
import { MatTabsModule } from '@angular/material/tabs';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogModule } from '@angular/material/dialog';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { CellManagerComponent } from './cell-manager/cell-manager.component';
import { PrinterManagerComponent } from './printer-manager/printer-manager.component';
import { ScannerComponent } from './scanner/scanner.component';
import { RouterModule } from '@angular/router';
import { WarehouseManagerComponent } from './warehouse-manager/warehouse-manager.component';
import { WarehouseCardComponent } from './warehouse-card/warehouse-card.component';
import { CityModule } from '../city/city.module';
import { WarehouseCareComponent } from './care/warehouse-care.component';

@NgModule({
  declarations: [
    WarehouseCareComponent,
    SelectorComponent,
    CellManagerComponent,
    ScannerComponent,
    PrinterManagerComponent,
    WarehouseManagerComponent,
    WarehouseCardComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    MatIconModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatAutocompleteModule,
    MatTableModule,
    MatCardModule,
    MatTabsModule,
    MatButtonToggleModule,
    MatProgressBarModule,
    MatCheckboxModule,
    MatDialogModule,
    RouterModule,
    DragDropModule,
    CityModule
  ],
  exports: [
    SelectorComponent,
    CellManagerComponent,
    ScannerComponent,
    PrinterManagerComponent,
    WarehouseManagerComponent,
    WarehouseCardComponent
  ]
})
export class WarehouseModule {}
